<div class="a00310">
    <div class="a00310-container" [style.top.px]="top" [style.right.px]="right" #divElement>
        <span [inlineSVG]="'/assets/icons/hook/red.svg' | assetPath"></span>
        <p>
            {{data.message}}
        </p>
    </div>
</div>
